module.exports = __webpack_public_path__ + "img/hd_outgoing_goods_2.8f67af9b.png";